import select from 'dom-select';

export const SelectTabs = (el) => {
  const ui = {
    el,
    select: select('.select', el),
    state: select('#find-state-label', el),
    tabs: select('.tabs', el)
  };

  const addEventListeners = () => {
    const options = select.all('.tabs__tab', ui.select);

    options.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });

    ui.select.addEventListener('change', (e) => {
      const { value } = e.target;
      ui.select.querySelector(`option[value=${value}]`).click();

      ui.el.dispatchEvent(new CustomEvent('openAtIndex', { bubbles: true, detail: { value: value.toLowerCase() } })); // eslint-disable-line
      const nameOfState = value.substring(value.indexOf(`select-tabs-${ui.el.id}-`) + `select-tabs-${ui.el.id}-`.length);
      ui.state.innerHTML = nameOfState.charAt(0).toUpperCase() + nameOfState.slice(1);
    });
  };

  const init = () => {
    addEventListeners();
  };

  init();
};

export default SelectTabs;
